"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingWorkerService = void 0;
var helpers_1 = require("../../helpers");
var types_1 = require("../../types");
var schema_service_1 = require("../schema-service");
var whitelist_service_1 = require("../whitelist-service");
var request_1 = require("./request");
var TrackingWorkerService = /** @class */ (function () {
    function TrackingWorkerService() {
        var _this = this;
        this.worker = null;
        this.salt = null;
        this.putWorker = function (worker) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (worker) {
                    this.destroy();
                    this.worker = worker;
                    this.request = new request_1.WorkerRequest(worker);
                    this.response = this.request.getResponse();
                    this.response.watch();
                }
                return [2 /*return*/];
            });
        }); };
        this.putConfig = function (config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (config) {
                    this.request.setConfig(config);
                }
                return [2 /*return*/];
            });
        }); };
        this.setCommitInterval = function (interval) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (interval <= 0) {
                    return [2 /*return*/];
                }
                this.request.setInterval(interval);
                return [2 /*return*/];
            });
        }); };
        this.setChecksumSalt = function (salt) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.response.putParameter('salt', salt);
                this.salt = salt;
                return [2 /*return*/];
            });
        }); };
        this.getWorker = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.worker];
            });
        }); };
        this.defineMetadata = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var client_metadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, schema_service_1.createMetadata)({
                            address: (0, helpers_1.addressOf)(user),
                        })];
                    case 1:
                        client_metadata = _a.sent();
                        this.request.defineMetadata({
                            visitorId: client_metadata.visitor.visitorId,
                            data: {
                                client: client_metadata.client,
                                visitor: client_metadata.visitor,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.pushWebLog = function (payload, user) { return __awaiter(_this, void 0, void 0, function () {
            var eventId, eventName, eventType, log, is_whitelisted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!payload) return [3 /*break*/, 2];
                        eventId = payload.eventId, eventName = payload.eventName, eventType = payload.eventType;
                        if (!eventId || !eventName || !eventType) {
                            throw new Error('Event metadata is invalid');
                        }
                        if (!Object.values(types_1.EventId).includes(eventId)) {
                            throw new Error('Event ID is not defined');
                        }
                        return [4 /*yield*/, (0, schema_service_1.createWebLogEvent)(payload.eventId, payload.eventType, payload.eventName)(payload, {
                                address: (0, helpers_1.addressOf)(user),
                            })];
                    case 1:
                        log = _a.sent();
                        is_whitelisted = whitelist_service_1.EventWhitelist.INSTANCE.isWhitelisted(payload.eventId);
                        this.request.defineMetadata({
                            visitorId: log.visitor.visitorId,
                            data: {
                                client: log.client,
                                visitor: log.visitor,
                            },
                        });
                        this.request.pushWebLog({
                            visitorId: log.visitor.visitorId,
                            data: log.event,
                            hash: log.hash,
                            config: {
                                is_whitelisted: is_whitelisted,
                            },
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.watchHeartBeat = function (href, user) { return __awaiter(_this, void 0, void 0, function () {
            var is_whitelisted, log, checksum;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        is_whitelisted = whitelist_service_1.EventWhitelist.INSTANCE.isWhitelisted(types_1.EventId.HeartBeat);
                        if (!(typeof window !== 'undefined' && user && is_whitelisted)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, schema_service_1.createHeartBeatEvent)(href)({
                                address: (0, helpers_1.addressOf)(user),
                            })];
                    case 1:
                        log = _b.sent();
                        checksum = (0, helpers_1.createChecksum)([log], {
                            visitor_id: log.visitor.visitorId,
                            address: user.address,
                            salt: (_a = this.salt) !== null && _a !== void 0 ? _a : 'Pegaxy',
                        });
                        this.request.pushHeartBeat({
                            visitorId: log.visitor.visitorId,
                            data: {
                                client: log.client,
                                visitor: log.visitor,
                                checksum: checksum,
                                events: [
                                    {
                                        id: types_1.EventId.HeartBeat,
                                        payload: log.event.payload,
                                        hash: log.hash,
                                    },
                                ],
                            },
                        });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.destroy = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.worker) {
                    this.worker.terminate();
                    this.worker = null;
                }
                return [2 /*return*/];
            });
        }); };
    }
    return TrackingWorkerService;
}());
exports.TrackingWorkerService = TrackingWorkerService;
